(() => {
  function init() {
    const section = document.getElementById('D4uBulkSection');
    if (!section) return;
    const details = section.querySelector('details');
    document.querySelectorAll('product-info').forEach(info => {
      if (info.querySelector('.d4u-bulk-jump')) return;
      const quantity = info.querySelector('.d4u-personalized input[name="quantity"], quantity-input');
      const anchor = document.createElement('a');
      anchor.href = '#D4uBulkSection';
      anchor.className = 'd4u-bulk-jump';
      anchor.textContent = 'Ordering several? Request bulk pricing';
      anchor.addEventListener('click', event => {
        event.preventDefault(); details.open = true;
        section.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        (form.hidden?status:section.querySelector('summary')).focus({preventScroll:true});
      });
      if (quantity) quantity.insertAdjacentElement('afterend', anchor);
      else (info.querySelector('.product__info-container') || info).prepend(anchor);
    });
    const form = section.querySelector('form');
    const lines = section.querySelector('[data-bulk-lines]');
    if (!lines || form.dataset.bulkReady) return;
    form.dataset.bulkReady = 'true';
    const template = lines.firstElementChild.cloneNode(true);
    const add = section.querySelector('[data-bulk-add]');
    add.hidden = false;
    function update() {
      let total = 0; const summary = [];
      Array.from(lines.children).forEach((row, index) => {
        const qty = row.querySelector('[data-bulk-qty]');
        const choice = row.querySelector('[data-bulk-variant]');
        qty.setCustomValidity('');
        qty.name = `contact[Line ${index + 1} quantity]`;
        choice.name = `contact[Line ${index + 1} options]`;
        row.querySelector('[data-bulk-remove]').hidden = lines.children.length === 1;
        const count = Number(qty.value);
        if (Number.isInteger(count) && count > 0) total += count;
        summary.push(`${qty.value} x ${choice.value} (variant ${choice.selectedOptions[0].dataset.variantId})`);
      });
      section.querySelector('[data-bulk-total]').textContent = `Total quantity: ${total}`;
      section.querySelector('[data-bulk-summary]').value = summary.join('\n');
      return total;
    }
    add.addEventListener('click', () => {
      if (lines.children.length >= 40) { status.textContent = 'You can include up to 40 combinations.'; return; }
      const row = template.cloneNode(true);
      row.querySelector('[data-bulk-qty]').value = '1';
      lines.append(row); update(); row.querySelector('select').focus();
    });
    lines.addEventListener('click', event => {
      if (event.target.matches('[data-bulk-remove]') && lines.children.length > 1) {
        event.target.closest('.d4u-bulk-line').remove(); update(); add.focus();
      }
    });
    lines.addEventListener('input', update); lines.addEventListener('change', update);
    const submit = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-quote-status]');
    let challenge = null, challengeAt = 0, requestKey = crypto.randomUUID(), pending = null, sending = false;
    const endpoint = (window.Shopify?.routes?.root || '/') + 'apps/3d4us-quotes';
    async function getChallenge() {
      const r = await fetch(endpoint + '/challenge', {headers:{Accept:'application/json'}});
      if (!r.ok) throw new Error('The quote service is not available yet. Please try again later or email 3d@3d4us.com.');
      challenge = (await r.json()).challenge;
      if (!challenge) throw new Error('The quote service returned an invalid response.');
      challengeAt = Date.now();
    }
    submit.disabled = false;
    details.addEventListener('toggle', () => { if (details.open && !challenge) getChallenge().catch(() => {}); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (sending) return;
      const total = update();
      if (total < 2 || total > 10000) lines.querySelector('[data-bulk-qty]').setCustomValidity('Request 2 to 10,000 items in total.');
      if (!pending && !form.reportValidity()) return;
      sending = true; submit.disabled = true; submit.textContent = 'Saving request...'; status.textContent = '';
      try {
        if (!challenge || Date.now() - challengeAt > 3500000) await getChallenge();
        if (Date.now() - challengeAt < 1100) await new Promise(resolve => setTimeout(resolve, 1100));
        if (!pending) pending = {requestKey, name:form.querySelector('[name="contact[name]"]').value,
          email:form.querySelector('[name="contact[email]"]').value, notes:form.querySelector('[name="contact[body]"]').value,
          website:form.querySelector('[name="website"]').value,
          items:Array.from(lines.children).map(row=>({variantId:row.querySelector('[data-bulk-variant]').selectedOptions[0].dataset.variantId,quantity:Number(row.querySelector('[data-bulk-qty]').value)}))};
        form.querySelectorAll('input,select,textarea,button').forEach(el=>el.disabled=true);
        const r = await fetch(endpoint + '/requests',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...pending,challenge})});
        const result = await r.json();
        if (!r.ok) {
          if (r.status >= 400 && r.status < 500) { pending = null; requestKey = crypto.randomUUID(); form.querySelectorAll('input,select,textarea,button').forEach(el=>el.disabled=false); }
          throw new Error(result.error || 'Unable to confirm the request. Click Retry to check it safely.');
        }
        if (!result.reference) throw new Error('Unable to confirm the request. Click Retry to check it safely.');
        status.textContent = 'Request ' + result.reference + ' received. We are working on it. A confirmation email will follow. This does not place an order.';
        form.before(status); form.hidden = true;
        const introduction=section.querySelector('h2 + p'); if(introduction)introduction.hidden=true;
        status.tabIndex=-1;status.focus({preventScroll:true});
        status.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      } catch (error) {
        status.textContent = error.message || 'Connection interrupted. Click Retry to check your request safely.';
        submit.disabled = false; submit.textContent = pending ? 'Retry same request' : 'Request a quote';
      } finally { sending = false; }
    });
    update();
  }
  init(); document.addEventListener('shopify:section:load', init);
})();
